import { computed, ref, watch } from '@vue/composition-api'
import store from '@/store'

export default function usePlans(type) {

  const refPlansListTable = ref(null)

  const tableColumns = [
    { key: 'name', sortable: true, label: 'Name' },
    { key: 'device', sortable: true, label: 'device' },
    { key: 'areas', sortable: true, label: 'areas' },
    { key: 'owner', sortable: true, label: 'owner' },

    { key: 'contract', sortable: true, label: 'contract' },


    { key: 'actions', label: 'actions' },
  ]

  const extairnalFilter = ref(null)
  const plans = ref([])

  const perPage = ref(10)
  const totalPlans = ref(0)
  const currentPage = ref(1)
  const perPageOptions = [5, 10, 25, 50, 100]
  const searchQuery = ref('')
  const sortBy = ref('created_at')
  const isSortDirDesc = ref(true)

  const requestStatus = ref(false)

  const dataMeta = computed(() => {
    const localItemsCount = refPlansListTable.value ? refPlansListTable.value.localItems.length : 0
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalPlans.value,
    }
  })


  const refetchData = () => {
    refPlansListTable.value.refresh()
  }

  const filter = ref({})

  watch([currentPage, perPage, searchQuery], () => {
    filter.value = {

      ...(searchQuery.value && { q: searchQuery.value })
    }
    Object.assign(filter.value, extairnalFilter.value)

    refetchData()
  })

  // watch([extairnalFilter], () => {

  //   Object.assign(filter.value,   extairnalFilter.value)
  //   refPlansListTable.value.refresh()
  //   extairnalFilter.value=null;

  // })

  const forceRefilter = (extairnalFilter) => {

    Object.assign(filter.value, extairnalFilter)
    refPlansListTable.value.refresh()
  }


  ///get comment for spefic plan



  const fetchPlans = (ctx, callback) => {

    requestStatus.value = true
    store.dispatch('plans/fetchPlans', {

      q: searchQuery.value,
      length: perPage.value,
      page: currentPage.value,
      sortBy: isSortDirDesc.value == true ? sortBy.value + ',desc' : sortBy.value + ',asc',
      type,
      ...filter.value

    }).then(response => {
      requestStatus.value = false

      const { data } = response.data.plans
      const { total } = response.data.plans.meta

      callback(data)

      totalPlans.value = total

    }).catch(() => {
      requestStatus.value = false
    })
  }



  return {
    fetchPlans,

    plans,
    refPlansListTable,
    tableColumns,
    perPage,
    totalPlans,
    currentPage,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    dataMeta,
    requestStatus,
    refetchData,
    extairnalFilter,
    forceRefilter
  }

}
